<template>
  <div
    data-qa="personal_data"
    :class="{ 'px-4': isMobile }"
    class="text-body-2 text-secondary--text text-center"
  >
    {{ t('Записываясь на', options) }}
    <span data-qa="personal_data_appointment_object_type_text">{{ t('приём', options) }}</span>,
    {{ t('вы даете согласие на', options) }}
    <a
      data-qa="personal_data_privacy_policy"
      target="_blank"
      href="/info/privacy-policy/"
      class="link-decoration-none primary--text d-inline"
    >
      {{ t('обработку персональных данных', options) }}
    </a>
    {{ t('и принимаете', options) }}
    <a
      data-qa="personal_data_terms_of_use"
      target="_blank"
      href="/info/terms-of-use/"
      class="link-decoration-none primary--text d-inline"
    >
      {{ t('пользовательское соглашение', options) }}
    </a>
  </div>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'

const { t, language } = I18NextVue
const options = { ns: language }

const isMobile = window.MOBILE_VERSION
</script>
